var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoTracker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 76,
    viewBox: "0 0 63 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.4246 75.1278C30.5027 75.1287 29.5911 74.9334 28.7504 74.5548C27.9098 74.1762 27.1593 73.6231 26.5489 72.9321L6.54037 50.2543L6.45068 50.1467C2.23155 45.1598 0 38.5692 0 31.0924C0.0884343 22.8158 3.43836 14.9082 9.32235 9.08671C15.2063 3.26525 23.1493 0 31.4264 0C39.7035 0 47.6465 3.26525 53.5305 9.08671C59.4145 14.9082 62.7644 22.8158 62.8528 31.0924C62.8528 38.2678 60.1405 46.132 56.2479 50.3261L36.2931 72.9285C35.6837 73.6191 34.9345 74.1722 34.0952 74.5514C33.2559 74.9305 32.3456 75.127 31.4246 75.1278ZM16.324 41.7264L31.4246 58.8325L46.579 41.6689C46.6293 41.6115 46.6759 41.5577 46.7261 41.5075C48.0392 40.1155 49.8725 35.4802 49.8725 31.1032C49.8049 26.2555 47.8318 21.6293 44.3798 18.2252C40.9278 14.821 36.2746 12.9125 31.4264 12.9125C26.5783 12.9125 21.925 14.821 18.473 18.2252C15.0211 21.6293 13.0479 26.2555 12.9803 31.1032C12.9803 34.1097 13.5615 38.4149 16.324 41.7264Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9422 34.9958C45.0185 35.6452 44.8606 37.7871 43.2569 39.2329C40.2726 41.9046 36.4078 43.3818 32.4023 43.3818C28.3969 43.3818 24.5321 41.9046 21.5478 39.2329C19.9441 37.7978 19.797 35.6452 20.8661 34.9958C21.9424 34.3393 23.5031 34.881 24.5937 35.8425C26.7398 37.7661 29.5204 38.8298 32.4023 38.8298C35.2843 38.8298 38.0649 37.7661 40.211 35.8425C41.3016 34.881 42.873 34.3393 43.9422 34.9958Z",
    fill: "#ED6E18"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 30.5672,
    y1: 75.4973,
    x2: 32.6121,
    y2: -30.2249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#F49943"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E83B39"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTracker);
export default __webpack_public_path__ + "static/media/LogoTracker.b826913750613bfbdef1d44f69dd5174.svg";
export { ForwardRef as ReactComponent };